import useInvoiceService, { INVOICE_STATUSES_OPTIONS } from 'domain/finance/invoice/useInvoiceService';
import React from 'react';
import { DateField, EnumField, TextField } from 'framework/ui/field';
import { DataGridLayout, List, ListPageLayout } from 'framework/list';
import { useVendorId } from '../routes';
import InvoiceLink from 'domain/finance/invoice/shared/field/InvoiceLink';

const RelatedInvoicesByVendor = () => {
  const id = useVendorId();
  const { search } = useInvoiceService();

  return (
    <List
      getDataMethod={async params => {
        return search({
          ...params,
          sort: {},
          filter: {
            ...params.filter,
            vendorId: {
              eq: id,
            },
          },
        });
      }}
    >
      <ListPageLayout>
        <DataGridLayout isSmallTable>
          <InvoiceLink source="id" nameSource="invoiceNumber" label="Invoice Number" />
          <EnumField source="status" label="Status" options={INVOICE_STATUSES_OPTIONS} />
          <DateField source="invoiceDate" label="Date" />
          <TextField source="description" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default RelatedInvoicesByVendor;
